export const errorCodeMap = {
    // 短信验证码相关
    19: 'ERROR_SEND_PHONE_VCODE_TOO_OFTEN',
    20: 'ERROR_WRONG_VERIFICATION_CODE',

    // 文件操作相关
    1001: 'ERROR_FILE_UPLOAD',
    1002: 'ERROR_FILE_UPLOAD_MESSAGE',
    2100: 'ERROR_FILE_IS_EMPTY',
    2101: 'ERROR_FILE_TYPE_DISCREPANCY',
    2102: 'ERROR_FILE_SPEC_EXCEEDS_THE_MAXIMUM_LIMIT',
    2104: 'ERROR_FILE_EXPORT_TEMPLATE_FAILED',
    2105: 'ERROR_FILE_EXPORT_FAILED',

    // 内容验证相关
    3000: 'ERROR_INVALID_POST_CONTENT',

    // 资源不存在相关
    2000: 'ERROR_DOES_NOT_EXIST',
    2001: 'ERROR_DOES_NOT_EXIST_DEVICE_COMMAND',
    2002: 'ERROR_DOES_NOT_EXIST_ACTION',
    2003: 'ERROR_DOES_NOT_EXIST_AGENT',
    2004: 'ERROR_DOES_NOT_EXIST_APP',
    2005: 'ERROR_DOES_NOT_EXIST_CONFIG',
    2006: 'ERROR_DOES_NOT_EXIST_DEVICE',
    2007: 'ERROR_DOES_NOT_EXIST_DEVICE_ALARM',
    2008: 'ERROR_DOES_NOT_EXIST_DEVICE_REPORT_DATA',
    2009: 'ERROR_DOES_NOT_EXIST_GATEWAY',
    2010: 'ERROR_DOES_NOT_EXIST_USER',
    2031: 'ERROR_NOT_EXIST_DEVICE',
    2034: 'ERROR_NOT_EXIST_IMEI_DEVICE',
    2039: 'ERROR_NOT_EXISTS_EMAIL',

    // 权限相关
    2012: 'ERROR_LACK_PERMISSION',
    2017: 'ERROR_LACK_PERMISSION_DEVICE',
    4002: 'ERROR_NOT_CURRENT_USER',
    4003: 'ERROR_USER_DISABLED',
    4004: 'ERROR_INVALID_TOKEN',
    4005: 'ERROR_ONLY_THE_SUPER_ADMINISTRATOR_CAN_CREATE_OR_MODIFY_DISTRIBUTORS',
    4011: 'ERROR_NO_PERMISSION',
    4012: 'ERROR_ONLY_ADMINISTRATOR_CAN_ADD_DEVICE',
    4018: 'ERROR_ONLY_ADMINISTRATOR_CAN_ADD_DEVICES',
    4023: 'ERROR_ONLY_ADMINISTRATOR_CAN_IMPORT',
    4024: 'ERROR_ONLY_SKF_ADMINISTRATOR_CAN_UNBIND_DEVICES',
    4025: 'ERROR_ONLY_ADMINISTRATOR_CAN_CREATE_GROUPS',
    4026: 'ERROR_NO_PERMISSION_TO_VIEW',
    4027: 'ERROR_ONLY_ADMINISTRATOR_CAN_DELETE_GROUPS',
    4028: 'ERROR_ONLY_ADMINISTRATOR_HAS_PERMISSION_TO_DISABLE_OR_ENABLE',
    4029: 'ERROR_ONLY_TEAM_LEADER_AND_ADMINISTRATOR_HAVE_PERMISSION',
    4030: 'ERROR_ONLY_SKF_ADMINISTRATORS_HAVE_PERMISSION',

    // 设备相关
    2011: 'ERROR_NOT_STORAGE',
    2013: 'ERROR_INCORRECT_EVENT_TYPE',
    2014: 'ERROR_NOT_EXIST_LORA_BAND',
    2015: 'ERROR_EXIST_EUI',
    2016: 'ERROR_NO_MODIFICATION_EUI',
    2024: 'ERROR_INVALID_SPACE',
    2027: 'ERROR_DEVICE_LORA_PLATFORM_REGISTRATION_FAILED',
    2029: 'ERROR_GATEWAY_PLATFORM_REGISTRATION_FAILED',
    2032: 'ERROR_INCORRECT_FREQUENCY_BAND',
    2033: 'ERROR_NOT_IMPORT_EUI',
    2035: 'ERROR_DEVICE_TYPE',
    2037: 'ERROR_EXISTS_IMEI',
    2038: 'ERROR_EXISTS_ADDR',

    // 用户相关
    2036: 'ERROR_EXISTS_EMAIL',
    2040: 'ERROR_EXISTS_USERNAME',
    2041: 'ERROR_EXISTS_USER',
    4006: 'ERROR_CREATE_EMAIL_ALREADY_EXISTS',
    4007: 'ERROR_UPDATE_EMAIL_ALREADY_EXISTS',
    4008: 'ERROR_THE_EMAIL_IS_NOT_REGISTERED',
    4013: 'ERROR_THIS_NUMBER_IS_OCCUPIED',
    4014: 'ERROR_ADDR_MUST_BE_AN_8_DIGIT_HEX_NUMBER',
    4015: 'ERROR_EUI_MUST_BE_AN_16_DIGIT_HEX_NUMBER',
    4016: 'ERROR_NK_MUST_BE_AN_32_DIGIT_HEX_NUMBER',
    4017: 'ERROR_AK_MUST_BE_AN_32_DIGIT_HEX_NUMBER',
    4019: 'ERROR_DEVICE_EUI_CANNOT_BE_MODIFIED',
    4020: 'ERROR_DEVICE_ADDR_CANNOT_BE_MODIFIED',
    4021: 'ERROR_DEVICE_NK_CANNOT_BE_MODIFIED',
    4022: 'ERROR_DEVICE_AK_CANNOT_BE_MODIFIED',

    // 认证相关
    4100: 'ERROR_PASSWORD_CANNOT_BE_EMPTY',
    4101: 'ERROR_PASSWORD',
    4102: 'ERROR_PLEASE_CONTACT_THE_SUPER_ADMINISTRATOR',
    4103: 'ERROR_KEY_CANNOT_BE_EMPTY',
    4104: 'ERROR_PLEASE_CONTACT_THE_ADMINISTRATOR',
    4105: 'ERROR_PASSWORD_EMPTY',
    4106: 'ERROR_THIS_EMAIL_HAS_BEEN_REGISTERED',
    4113: 'ERROR_PASSWORD_STRENGTH',
    4114: 'ERROR_LOGIN_LOCKED',

    // 其他错误
    2023: 'ERROR_EXECUTOR_BUSY',
    2025: 'ERROR_OCEAN_CONNECT_PLATFORM_REGISTRATION_FAILED',
    2026: 'ERROR_OCEAN_CONNECT_PLATFORM_REGISTRATION_FAILED_CONTENT',
    2028: 'ERROR_DEVICE_LORA_PLATFORM_REGISTRATION_FAILED_CONTENT',
    2030: 'ERROR_GATEWAY_PLATFORM_REGISTRATION_FAILED_CONTENT',
    4111: 'ERROR_ILLEGAL_OPERATION',
    4112: 'ERROR_ILLEGAL_PASSWORD',
};

// ?code=xxxx
// {
//     code: xxx,
//     data: ''
// }
